import gql from 'graphql-tag';

export default gql`
fragment UserProductDiscountFragment on UserProductDiscount {
    id
    user_id
    is_active
    active_from
    active_to
    created_at
    updated_at
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/UserProductDiscountFragment.ts